import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useNavigate } from "react-router";
import InputComponent from "./commonComponents/InputComponent";
import styled from 'styled-components'
import { performRegistration } from "../slices/authSlice";
import { useDispatch, useSelector } from "react-redux";


const SignupForm = () => {
    const [fullName, setFullName] = useState("");
    const [username, setUsername] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const accessToken = useSelector((state) => state.auth.userData?.accessToken);

    useEffect(() => {
        if (accessToken) {
            navigate('/dashboard');
        }
    }, [accessToken])

    const handleRegister = async () => {
        setLoading(true);

        if (!email || !password || !confirmPassword || !username) {
            toast.warning("Please fill all details", {
                position: "top-right",
                autoClose: 5000,
                pauseOnHover: true,
                theme: "dark",
                className: "toastify",
            })

            setLoading(false);
            return;
        }

        if (password !== confirmPassword) {
            toast.warning("Password mismatch", {
                position: "top-right",
                autoClose: 5000,
                pauseOnHover: true,
                theme: "dark",
                className: "toastify",
            })
            setLoading(false);
            return;
        }

        if (password.length <= 7) {
            toast.warning("Please keep password length more than 7", {
                position: "top-right",
                autoClose: 5000,
                pauseOnHover: true,
                theme: "dark",
                className: "toastify",
            })
            setLoading(false);
            return;
        }

        if (email && password && username && password.length > 7) {

            try {
                dispatch(performRegistration({ fullName, email, username, password }))

            } catch (error) {
                const errMsg = error.response.data.message || "Some error occured"
                toast.error(errMsg, {
                    position: "top-right",
                    autoClose: 5000,
                    pauseOnHover: true,
                    theme: "dark",
                    className: "toastify",
                })
                setLoading(false);
                return;
            }
        }
    }


    return (
        <Box>
            <InputComponent
                state={fullName}
                setState={setFullName}
                type="text"
                placeholder="Full Name"
                required={true}
            />
            <InputComponent
                state={email}
                setState={setEmail}
                type="email"
                placeholder="Email"
                required={true}
            />
            <InputComponent
                state={username}
                setState={setUsername}
                type="text"
                placeholder="Username"
                required={true}
            />
            <InputComponent
                state={password}
                setState={setPassword}
                type="password"
                placeholder="Password"
                required={true}
            />
            <InputComponent
                state={confirmPassword}
                setState={setConfirmPassword}
                type="password"
                placeholder="Confirm Password"
                required={true}
            />

            <button disabled={loading} onClick={handleRegister} className="customBtn">
                {loading ? "Loading" : "Signup"}
            </button>
        </Box>
    );
};

export default SignupForm;


const Box = styled.div`
display: flex;
flex-direction: column;
width: 100%;
align-items: center;


.customBtn {
  text-align: center;
  padding: 1.2rem 2.5rem;
  border-radius: 0.40rem;
  cursor: pointer;
  margin: 1rem;
  font-size: 2.3rem;
  font-weight: 600;
  background-color: var(--orange);
  color: var(--white);
  border-style: none;
}


`


